/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react'
import { LABEL_BTN_CANCEL } from 'src/constants/constant';
import CsvService from 'src/services/dataExport.service';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { FormControlLabel, FormGroup, Typography } from '@mui/material';
import MUICheckbox from '../MUICheckbox/MUICheckbox';
import { NotificationManager } from 'react-notifications';
import { exportTriggerCustomFieldReport, getTriggerCustomFieldData } from 'src/services/triggerService';
import { buildReportFileName } from '../utils/buildReportFileName';
import moment from 'moment';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps): JSX.Element {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 2 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

interface PropsType {
    id?: number;
    name?: string;
    closeModal: () => void;
}

function ExportTriggerCustomReport({ id, name, closeModal }: PropsType): JSX.Element {

    const [value, setValue] = useState(0);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedFields, setSelectedFields] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState('');
    const [columnListData, setColumnListData] = useState([])
    const [isDataLoading, setIsDataLoading] = useState<boolean>(false)
    const [isExportLoading, setIsExportLoading] = useState<boolean>(false)

    useEffect(() => {
        console.log("xx")
        setIsDataLoading(true)
        getTriggerCustomFieldData().then(
            (res: any) => {
                console.log("RES", res)
                if (res.status === 200) {
                    if (res.data.result === 1) {
                        setColumnListData(res.data.data)
                    }
                }
            }
        )
            .catch(e => console.log("Error", e))
            .finally(() => setIsDataLoading(false))
    }, [id])

    function a11yProps(index: number): { id: string; 'aria-controls': string } {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number): void => {
        setValue(newValue);
    };

    const filteredColumnList = columnListData.filter((field: string) =>
        field.toLowerCase().includes(inputValue.toLowerCase())
    );

    const handleSelectAll = useCallback((): void => {
        setSelectAll(prevSelectAll => !prevSelectAll);
        setSelectedFields(() =>
            !selectAll ? filteredColumnList.map((field: string) => field) : []
        );
    }, [selectAll, filteredColumnList]);

    const handleFieldSelection = useCallback((field: string): void => {
        setSelectedFields(prevSelectedFields => {
            const updatedSelection = prevSelectedFields.includes(field)
                ? prevSelectedFields.filter(item => item !== field)
                : [...prevSelectedFields, field];

            // Update Select All state based on selection
            setSelectAll(updatedSelection.length === filteredColumnList.length);
            return updatedSelection;
        });
    }, [filteredColumnList]);

    const handleExportReport = (): void => {
        setIsExportLoading(true)
        if (selectedFields.length > 0) {
            const data = {
                "listTriggerId": id,
                "columns": selectedFields
            }

            exportTriggerCustomFieldReport(data).then(
                (res: any) => {
                    console.log("Download", res)
                    if (res.status === 200) {
                        if (res.data.result === 1 && res.data.data && res.data.data.length > 0) {

                            const reportData: any = res.data.data;
                            const data: any = [];
                            for (const item of reportData) {
                                const newItem: any = {}
                                for (const field of selectedFields) {
                                    if (field === 'EventTime' && item[field]) {
                                        newItem[field] = moment(item[field]).format("MM-DD-YYYY HH:mm:ss");
                                    } else {
                                        newItem[field] = item[field];
                                    }
                                }
                                data.push(newItem)
                            }

                            console.log("XXXX", data)
                            const csvData = CsvService.jsonToCsv(data);
                            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                            CsvService.downloadCsvFile(
                                csvData,
                                buildReportFileName(id ?? '', name ?? '', 'CustomReport')
                            );

                        } else {
                            NotificationManager.error('No data available for download', '', 5000);
                        }
                    }
                }
            )
                .catch(e => console.log("Error", e))
                .finally(() => setIsExportLoading(false))
        } else {
            NotificationManager.error('Please select data field to download the report', '', 5000);
        }

    }



    return (
        <React.Fragment>
            <div className="px-[16px] pt-[10px]">
                {/* Campaign Name */}
                <div className="mb-[20px] w-full relative">
                    <div className="border border-inputborder bg-[#f5f5f5] text-center text-[18px] font-semibold rounded-md p-[7px] text-muted">
                        {name}
                    </div>
                </div>
            </div>
            <div>
                <Box sx={{ width: '100%', padding: 0 }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="basic tabs example"
                            TabIndicatorProps={{
                                style: {
                                    backgroundColor: "#D6242C",
                                }
                            }}
                        >
                            <Tab label="Data Fields" {...a11yProps(0)} disableRipple sx={{
                                color: '#D6242C',
                                fontWeight: '600',
                                '&.Mui-selected': {
                                    color: '#D6242C',
                                },
                                paddingLeft: '22px'
                            }} />
                        </Tabs>
                    </Box>

                    <div className="form-control  border-b-[1px] border-[#D9D9D9] pb-2 w-full pt-2" style={{ borderTop: 'none' }}>
                        <input
                            type="text"
                            placeholder="Search fields"
                            onChange={(e) => setInputValue(e.target.value)}
                            style={{
                                border: '0',
                                background: 'transparent url(/assets/images/icons/SearchIcon.svg) no-repeat 22px',
                                paddingLeft: '50px',
                                fontSize: '14px',
                                fontWeight: '400',
                                color: '#3a3a3a',
                                width: '100%', // Ensure the field takes the full width
                            }}
                        />
                    </div>
                    <CustomTabPanel value={value} index={0}>






                        <div style={{ padding: '0 ' }}>
                            {isDataLoading ? (
                                <div className='flex justify-center items-center relative '><span className="loading loading-spinner text-primary"></span></div>
                            ) : (
                                <div style={{ paddingLeft: '8px', marginBottom: '40px' }}>
                                    {filteredColumnList.length > 0 &&
                                        <FormGroup>
                                            <FormControlLabel
                                                control={<MUICheckbox checked={selectAll} onChange={handleSelectAll} />}
                                                label={<Typography sx={{
                                                    fontWeight: 'bold', fontSize: '14px',
                                                    color: '#3a3a3a'
                                                }}>Select All</Typography>}
                                            />
                                        </FormGroup>
                                    }
                                    {filteredColumnList.length > 0 ? (
                                        filteredColumnList.map((field: string, index) => (
                                            <div style={{ padding: '0 16px 5px 20px' }} key={index}>
                                                <FormGroup key={index}>
                                                    <FormControlLabel
                                                        control={<MUICheckbox checked={selectedFields.includes(field)} onChange={() => handleFieldSelection(field)} />}
                                                        label={<Typography>{`${field}`}</Typography>}
                                                    />
                                                </FormGroup>
                                            </div>
                                        ))
                                    ) : (
                                        <Typography variant="body2" style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '14px' }}>
                                            There are no records to display.
                                        </Typography>
                                    )}
                                </div>
                            )}
                        </div>

                    </CustomTabPanel>
                </Box>
            </div>
            <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                <div className="w-full relative col-span-3">
                    <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#e0e0e0] hover:border-[#e0e0e0] disabled:bg-[#f0f0f0] disabled:text-muted" disabled={isExportLoading} onClick={closeModal}>{LABEL_BTN_CANCEL}</button>
                </div>
                <div className="w-full relative col-span-3">
                    <button type="button" className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]" onClick={handleExportReport} disabled={isExportLoading}>{isExportLoading ? <span className="loading loading-spinner loading-xs text-white"></span> : 'Download'}</button>
                </div>
            </div>
        </React.Fragment>
    )
}

export default ExportTriggerCustomReport